import React from "react";

function Home() {
  return (
    <div className="bg-blue-500 p-12 text-center flex flex-col justify-center items-center" style={{ minHeight: 'calc(100vh - 64px)' }}>
        <h1 className="text-white text-4xl font-bold">Hi 👋, I'm Raihan Presiden Washil</h1>
        <p className="text-white">A passionate full stack web developer from Indonesia</p>
    </div>
  );
}

export default Home;